import SystemConfigEntry from "../domain/SystemConfigEntry";
import WsService from "./WsService";
import UserSessionService from "./UserSessionService";
import BasicAuthGenerator from "../utils/BasicAuthGenerator";

const ENDPOINT_BASE = "/system-config";

export default class SystemConfigService {
  static retrieveConfigEntry(systemConfigKey) {
    let endpoint = ENDPOINT_BASE + "?key=" + systemConfigKey;
    return WsService.get(endpoint, {}, 200).then(
      response => {
        return new SystemConfigEntry(response);
      },
      response => {
        return response;
      });
  }

  static retrieveConfigEntryUsingRegisteringPartnerCred(systemConfigKey) {
    let endpoint = ENDPOINT_BASE + "?key=" + systemConfigKey;
    let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();

    let headers = {
      "Authorization": BasicAuthGenerator.create(registrationHeaders["registering-partner-username"], registrationHeaders["registering-partner-password"])
    };
    return WsService.getWithHeaders(endpoint, {}, 200, headers).then(
      response => {
        return new SystemConfigEntry(response);
      },
      response => {
        return response;
      });
  }

}
